import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from '../Button';
import Dropdown from '../inputs/Dropdown';
import DateInput from '../inputs/DateInput';
import PropTypes from 'prop-types';
import React from 'react';
import { FaTimes } from "react-icons/fa";
// import { generateReport } from "../../api/report/GenerateReport"
import { fetchGenerateReport } from '../../api/admin/AdminDashboardAPI';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const GenerateReportModal = ({
    isOpen,
    onClose,
    formData,
    setFormData
}) => {
    const { selectedReportType = 'none', selectedFileType = 'none', reportStartDate = "", reportEndDate = "" } = formData || {};

    const reportTypeMap = {
        status: 'member_status',
        swag: 'member_swag',
        participation: 'member_event_summary',
        full: 'full_member',
        event: 'events',
        committee: 'committee'
    };

    const fileTypeMap = {
        csv: 'csv',
        xlsx: 'excel'
    };

    const handleReportTypeChange = (e) => {
        setFormData({ ...formData, selectedReportType: e.target.value });
    };

    const handleFileTypeChange = (e) => {
        setFormData({ ...formData, selectedFileType: e.target.value });
    };

    const handleStartDateChange = (e) => {
        setFormData({ ...formData, reportStartDate: e.target.value });
    };

    const handleEndDateChange = (e) => {
        setFormData({ ...formData, reportEndDate: e.target.value });
    };

    const handleReset = () => {
        setFormData({
            selectedReportType: 'none',
            selectedFileType: 'none',
            reportStartDate: "",
            reportEndDate: ""
        });
    };

    const handleGenerateReport = async () => {
        if (selectedReportType === 'none' || selectedFileType === 'none') {
            alert("Please select a report type and file type.");
            return;
        }

        const report = reportTypeMap[selectedReportType];
        const format = fileTypeMap[selectedFileType];

        try {
            await generateReport({ report, format });
            onClose();
        } catch (err) {
            console.error(err);
            alert("Failed to download the report.");
        }
    };

    // moved generateReport into here so the toasts would pop up
    const generateReport = async ({ report, format }) => {
        if (!report || !format) {
            throw new Error("Both report and format must be specified.");
        }
        try {
            toast.loading("Generating Report...")
            const response = await fetchGenerateReport(report, format);
            if (response.ok && response.body) {
                toast.dismiss();
                toast.success("Report Downloading!")
            } else {
                toast.dismiss();
                toast.success("Report Downloading!")
            }
    
            const blob = await response.blob();
    
            const disposition = response.headers.get("Content-Disposition");
            const now = new Date();

            // Get year, month, and day
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');       

            const dateString = `${year}-${month}-${day}`; // Format as YYYY-MM-DD

            let filename = `${report}_report_${dateString}.${format === 'excel' ? 'xlsx' : 'csv'}`;
    
            if (disposition && disposition.includes("filename=")) {
                const match = disposition.match(/filename="?(.+?)"?$/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }
    
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
    
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
    
        } catch(error) {
            toast.dismiss();
            toast.error(`Failed to download ${report} report as ${format}`)
        }
    };

    const handleStartDatePicker = () => {

        if (selectedReportType === 'event') {
            return (
                <div className="form-field mt-1 w-75">
                    <DateInput
                        id="report-start-date"
                        className="form-input"
                        label="Start Date"
                        value={reportStartDate}
                        setValue={handleStartDateChange}
                    />
                </div>
            )
        }
    }

    const handleEndDatePicker = () => {

        if (selectedReportType === 'event') {
            return (
                <div className="form-field mt-1 w-75">
                    <DateInput
                        id="report-end-date"
                        className="form-input"
                        label="End Date"
                        value={reportEndDate}
                        setValue={handleEndDateChange}
                    />
                </div>
            )
        }
    }


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Generate Report Modal"
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                    <h2 className="text-start mb-0">Generate Report</h2>
                    <div className="d-flex flex-row justify-content-end align-items-center me-1">
                        <button className="close-btn" onClick={onClose}>
                            <FaTimes />
                        </button>
                    </div>
                </div>
                <div className="form-field w-75">
                    <Dropdown
                        id="report-types-dropdown"
                        name="reportTypes"
                        options={[
                            { value: 'none', label: '-- Select Report Type --' },
                            { value: 'status', label: 'Member Status Report' },
                            { value: 'swag', label: 'Member Swag Report' },
                            { value: 'participation', label: 'Member Participation Report' },
                            { value: 'full', label: 'Full Member Report' },
                            { value: 'event', label: 'Event Report' },
                            { value: 'committee', label: 'Committee Report' },
                        ]}
                        onChange={handleReportTypeChange}
                        className="form-input"
                        label="Report Type"
                        value={selectedReportType}
                        required
                    />
                </div>
                <div className="form-field mt-1 w-75">
                    <Dropdown
                        id="file-types-dropdown"
                        name="fileTypes"
                        options={[
                            { value: 'none', label: '-- Select File Type --' },
                            { value: 'csv', label: 'CSV' },
                            { value: 'xlsx', label: 'XLSX' },
                        ]}
                        onChange={handleFileTypeChange}
                        className="form-input"
                        label="File Type"
                        value={selectedFileType}
                        required
                    />
                </div>

                {handleStartDatePicker()}

                {handleEndDatePicker()}

                <div className="d-flex flex-row justify-content-center align-items-center two-button-container">
                    <div className="me-3">
                        <Button
                            id="reset-button"
                            type={BUTTON_TYPES.outline}
                            buttonText="Reset"
                            action={handleReset}
                        />
                    </div>
                    <Button
                        id="generate-report-button"
                        type={BUTTON_TYPES.primary}
                        buttonText="Generate Report"
                        action={handleGenerateReport}
                    />
                </div>
            </>
        </Modal>
    );
};

GenerateReportModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
};

export default GenerateReportModal;
